import React from 'react';

function SensorRefTh() {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_241_995)">
        <path
          d="M72.5225 21.0339H7.47852V50.1759H72.5225V21.0339Z"
          fill="white"
        />
        <path
          d="M72.38 20.9941H7.62C6.726 20.9941 6 20.2701 6 19.3741V14.5161C6 12.7281 7.45 11.2781 9.238 11.2781H70.762C72.55 11.2781 74 12.7281 74 14.5161V19.3741C74 20.2681 73.276 20.9941 72.38 20.9941Z"
          fill="#F7F4F1"
        />
        <path
          d="M72.38 50.178H7.62C6.726 50.178 6 50.902 6 51.798V56.656C6 58.444 7.45 59.894 9.238 59.894H70.762C72.55 59.894 74 58.444 74 56.656V51.798C74 50.904 73.276 50.178 72.38 50.178V50.178Z"
          fill="#F7F4F1"
        />
        <path
          d="M63.5097 64.3261H51.9657C51.0717 64.3261 50.3457 63.6021 50.3457 62.7061V59.8901H65.1277V62.7061C65.1277 63.6001 64.4037 64.3261 63.5077 64.3261H63.5097Z"
          fill="#E0DDDA"
        />
        <path
          d="M60.0452 68.7202H55.4272C53.4372 68.7202 51.8232 67.1062 51.8232 65.1162V64.3262H63.6492V65.1162C63.6492 67.1062 62.0352 68.7202 60.0452 68.7202V68.7202Z"
          fill="white"
        />
        <path
          d="M26.4141 65.8041H18.1081C16.3201 65.8041 14.8701 64.3541 14.8701 62.5661V59.8921H29.6521V62.5661C29.6521 64.3541 28.2021 65.8041 26.4141 65.8041Z"
          fill="#E0DDDA"
        />
        <path
          d="M74.8002 19.374V14.516C74.8002 12.29 72.9882 10.478 70.7622 10.478H9.2382C7.0122 10.478 5.2002 12.29 5.2002 14.516V19.374C5.2002 20.374 5.8102 21.234 6.6782 21.602V49.568C5.8102 49.936 5.2002 50.796 5.2002 51.796V56.654C5.2002 58.88 7.0122 60.692 9.2382 60.692H14.0702V62.568C14.0702 64.794 15.8822 66.606 18.1082 66.606H26.4142C28.6402 66.606 30.4522 64.794 30.4522 62.568V60.692H49.5462V62.708C49.5462 63.708 50.1562 64.568 51.0242 64.936V65.116C51.0242 67.544 53.0002 69.52 55.4282 69.52H60.0462C62.4742 69.52 64.4502 67.544 64.4502 65.116V64.936C65.3182 64.568 65.9282 63.708 65.9282 62.708V60.692H70.7602C72.9862 60.692 74.7982 58.88 74.7982 56.654V51.796C74.7982 50.796 74.1882 49.936 73.3202 49.568V21.604C74.1882 21.236 74.7982 20.376 74.7982 19.376L74.8002 19.374ZM6.8002 14.518C6.8002 13.174 7.8942 12.08 9.2382 12.08H70.7622C72.1062 12.08 73.2002 13.174 73.2002 14.518V19.376C73.2002 19.828 72.8322 20.194 72.3802 20.194H7.6202C7.1682 20.194 6.8002 19.826 6.8002 19.376V14.518ZM71.7222 49.378H8.2782V21.834H71.7222V49.378ZM28.8542 62.568C28.8542 63.912 27.7602 65.006 26.4162 65.006H18.1102C16.7662 65.006 15.6722 63.912 15.6722 62.568V60.692H28.8542V62.568ZM60.0482 67.922H55.4302C53.8882 67.922 52.6322 66.67 52.6262 65.128H62.8522C62.8462 66.67 61.5902 67.922 60.0482 67.922V67.922ZM64.3302 62.708C64.3302 63.16 63.9622 63.526 63.5102 63.526H51.9662C51.5142 63.526 51.1462 63.158 51.1462 62.708V60.692H64.3282V62.708H64.3302ZM73.2002 56.654C73.2002 57.998 72.1062 59.092 70.7622 59.092H9.2382C7.8942 59.092 6.8002 57.998 6.8002 56.654V51.796C6.8002 51.344 7.1682 50.976 7.6202 50.976H72.3802C72.8322 50.976 73.2002 51.344 73.2002 51.794V56.652V56.654Z"
          fill="#84827E"
        />
        <path
          d="M48.7465 28.9819C50.6645 28.9819 52.1625 30.5679 52.1625 32.5039C52.1625 34.4399 50.6625 36.0259 48.7465 36.0259C46.8305 36.0259 45.3125 34.4059 45.3125 32.5039C45.3125 30.6019 46.8285 28.9819 48.7465 28.9819V28.9819ZM48.7465 34.0899C49.5665 34.0899 50.2465 33.3759 50.2465 32.5039C50.2465 31.6319 49.5665 30.9179 48.7465 30.9179C47.9265 30.9179 47.2465 31.6159 47.2465 32.5039C47.2465 33.3919 47.9445 34.0899 48.7465 34.0899ZM56.3825 29.1919H58.4745L50.3325 42.1259H48.2925L56.3805 29.1919H56.3825ZM57.8825 35.1879C59.8005 35.1879 61.2825 36.7739 61.2825 38.7099C61.2825 40.6459 59.8005 42.2319 57.8825 42.2319C55.9645 42.2319 54.4485 40.6099 54.4485 38.7099C54.4485 36.8099 55.9645 35.1879 57.8825 35.1879V35.1879ZM57.8825 40.2959C58.7025 40.2959 59.3645 39.5819 59.3645 38.7099C59.3645 37.8379 58.7025 37.1239 57.8825 37.1239C57.0625 37.1239 56.3665 37.8219 56.3665 38.7099C56.3665 39.5979 57.0645 40.2959 57.8825 40.2959Z"
          fill="url(#paint0_linear_241_995)"
        />
        <path
          d="M21.8962 30.5681C21.8962 31.8221 20.8502 32.8521 19.5782 32.8521C18.3062 32.8521 17.2422 31.8241 17.2422 30.5681C17.2422 29.3121 18.2882 28.2141 19.5782 28.2141C20.8682 28.2141 21.8962 29.2601 21.8962 30.5681V30.5681ZM19.5602 31.4401C20.0662 31.4401 20.4662 31.0401 20.4662 30.5521C20.4662 30.0641 20.0642 29.6461 19.5602 29.6461C19.0902 29.6461 18.6702 30.0461 18.6702 30.5521C18.6702 31.0581 19.0882 31.4401 19.5602 31.4401ZM28.6242 29.7661C30.3502 29.7661 31.9182 30.5341 33.0342 31.7021L31.5702 33.3241C30.8562 32.5561 29.5482 32.0861 28.5022 32.0861C26.3762 32.0861 24.5622 33.9521 24.5622 36.3741C24.5622 38.7961 26.3742 40.6801 28.5022 40.6801C29.5482 40.6801 30.8562 40.1921 31.5702 39.4421L33.0342 41.0281C31.9182 42.2301 30.3502 42.9981 28.6242 42.9981C25.1202 42.9981 22.4002 39.9641 22.4002 36.3741C22.4002 32.7841 25.1202 29.7681 28.6242 29.7681V29.7661Z"
          fill="url(#paint1_linear_241_995)"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_241_995"
          x="3.8002"
          y="9.07803"
          width="75.5996"
          height="65.042"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx="1.6" dy="1.6" />
          <feGaussianBlur stdDeviation="1.5" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_241_995"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_241_995"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_241_995"
          x1="47.5587"
          y1="30.167"
          x2="56.1813"
          y2="42.0881"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_241_995"
          x1="19.4633"
          y1="29.5364"
          x2="29.3879"
          y2="41.6966"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D1AD" />
          <stop offset="1" stopColor="#00A872" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default SensorRefTh;
